import brigadoon from "../assets/brigadoon.jpeg";
import signature from "../assets/signature.png";
import "./Hero.css";

const Hero = ({ links }) => {
  const handleScrollTo = (ref) => {
    ref.current?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      className="heroSection"
      style={{
        backgroundImage: `url(${brigadoon})`,
      }}
    >
      <div className="heroOverlay" />
      <div className="contentContainer">
        <div className="heroTextContent">
          <div style={{ display: "flex" }} className="titleContainer">
            <h1>Sacred Cleansing</h1>
            <img src={signature} alt="by Linda Rooney" />
          </div>
          <p className="tagline">for Homes, Land & Businesses</p>
        </div>
        <nav className="navBar">
          <ul className="navItemList">
            {links.map(({ title, ref }) => (
              <li
                key={title}
                onClick={() => handleScrollTo(ref)}
                className="link"
              >
                {title.toUpperCase()}
              </li>
            ))}
          </ul>
        </nav>
      </div>
    </section>
  );
};

export default Hero;
